import ForummLogoText from '@public/images/ForumLogoText.svg'
import SignUpForm from '@components/authforms/SignUpForm'
import React from 'react'
import EmptyLayout from '@layouts/EmptyLayout'
import Box from '@components/base/Box'
import { useTheme } from '@libs/useTheme'
import CircleMesh from '@public/CircleMesh.png'
import Astronaut from '@public/Astronaut.png'
import ForummLogo from '@public/ForummLogo2025.png'

export default function CreateAccountPage() {
  const { theme } = useTheme()
  return (
    <Box
      color={'backgroundColour'}
      className="min-h-screen w-screen relative overflow-x-hidden overflow-y-auto"
    >
      <Box className="flex justify-center min-h-screen w-full items-start lg:items-center relative px-3 py-4 sm:px-6 sm:py-6">
        <span
          className={`absolute bg-[#03fff5] size-full max-h-[70%] max-w-4/5 sm:max-w-5xl z-10 origin-left sm:translate-x-[15%] sm:translate-y-[-22%] sm:scale-x-150 translate-x-[4%] translate-y-[6%]`}
        ></span>
        <Box
          className={`absolute size-[130vh] translate-x-[40%] translate-y-[50%] right-0 bottom-0 z-20`}
          style={{
            backgroundImage: `url(${CircleMesh.src})`,
            backgroundSize: '100% 100%',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        ></Box>
        <span
          className={`absolute bg-[#ff00df] size-full max-h-[70%] max-w-4/5 sm:max-w-5xl z-20 sm:translate-x-[5%] sm:translate-y-[-13%] translate-x-[2%] translate-y-[2%]`}
        ></span>
        <Box className="absolute size-[100vh] translate-x-[40%] msd:translate-x-[40%] lwsg:translate-x-[25%] translate-y-[10%] right-0 bottom-0 z-40 ">
          <Box
            className={`absolute size-[100vh] animate-sway`}
            style={{
              backgroundImage: `url(${Astronaut.src})`,
              backgroundSize: '100% 100%',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          ></Box>
        </Box>
        <Box className="flex justify-center items-start lg:items-center w-full max-w-5xl overflow-hidden bg-sky-500 relative z-50 min-h-[calc(100vh-2rem)] lg:min-h-0 lg:h-[min(95vh,820px)] pb-0">
          <span
            className={`absolute bg-white size-full z-30 pb-2`}
            style={{ border: '3px solid #EBE064' }}
          ></span>
          {/* <Box */}
          {/*   className={`absolute top-0 left-0 translate-x-[-10%] translate-y-[330%] z-50 -rotate-90 origin-left`} */}
          {/* > */}
          {/*   <ForummLogoText /> */}
          {/* </Box> */}
          <Box className="w-full sm:w-11/12 md:w-4/5 z-50 px-4 py-5 sm:px-6 sm:py-6 flex justify-center items-start overflow-y-visible lg:overflow-y-auto relative min-h-full lg:h-full">
            <SignUpForm />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
CreateAccountPage.Layout = EmptyLayout
